import { StepLogger } from "analytics/funnel";
import { BFF69 } from "fields/langCodes";
import { History } from "history";
import L10n from "localization";
import GenFlashcardsNav, { formatLangName } from "./genFlashcardsNav";
import { OnboardingGoalInfo } from "./onboardingModal";
import SingleSelectNav, { IPromptOption } from "./singleSelectNav";

interface IProps {
  dismiss: () => Promise<void>;
  history: History;
  onAddToInbox: () => void;
  langName: string;
  langCode: BFF69;
  motivation: string;
  proficiency: string;
  logStep: StepLogger;
}
export default function GoalLanguageContextNav(props: IProps) {
  const opts: IPromptOption[] = [
    { name: L10n.localize((s) => s.onboarding.langContextGeneralUsage), val: "general usage" },
    {
      name: L10n.localize((s) => s.onboarding.langContextPublicTransit),
      val: "using public transit",
    },
    {
      name: L10n.localize((s) => s.onboarding.langContextRestaurant),
      val: "at a restaurant (ordering, making a reservation, paying the bill, ...)",
    },
    {
      name: L10n.localize((s) => s.onboarding.langContextHotel),
      val: "hotel (check-in, check-out, reservation, ...)",
    },
    {
      name: L10n.localize((s) => s.onboarding.langContextShopping),
      val: "shopping (getting prices, asking for sizes, ...)",
    },
    {
      name: L10n.localize((s) => s.onboarding.langContextWork),
      val: "work (general topics around an office, project planning, meetings, ...)",
    },
    {
      name: L10n.localize((s) => s.onboarding.langContextCasualConversations),
      val: "casual conversations (small talk)",
    },
  ];
  return (
    <SingleSelectNav
      title={formatLangName(props.langName)}
      description={L10n.localize((s) => s.onboarding.langContextNavDescription)}
      options={opts}
      dismiss={props.dismiss}
      otherPrompt={L10n.localize((s) => s.onboarding.langContextNavDescription)}
      history={props.history}
      onNav={(opt) => {
        const goal: OnboardingGoalInfo = {
          goal: "lang",
          langName: props.langName,
          langCode: props.langCode,
          motivation: props.motivation,
          proficiency: props.proficiency,
          context: opt.val,
        };
        const prompt = `Context: user is learning a language and wants flashcards to help them learn it.
Language IETF BCP 47 language tag: ${goal.langCode}.
User's motivation for learning language: ${goal.motivation}.
CEFR proficiency level: ${goal.proficiency === "None" ? "None" : goal.proficiency}.
Primary usage context: ${opt.val}.
`;
        return (
          <GenFlashcardsNav
            prompt={prompt}
            dismiss={props.dismiss}
            history={props.history}
            onAddToInbox={props.onAddToInbox}
            logStep={props.logStep}
            goal={goal}
          />
        );
      }}
    />
  );
}
